<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>bug_report</md-icon>
          </div>
          <h4 class="title" v-if="!inspectionId">Create New Inspections</h4>
          <h4 class="title" v-else>Update Inspections</h4>
        </md-card-header>

        <md-card-content>
            <md-field>
                <label>Client</label>
                <md-select placeholder="Select Client" v-model="clientId">
                    <md-option v-for="client in clientList" :key="client._id" :value="client._id">{{ client.companyName }}</md-option>
                </md-select>
          </md-field>
          <md-field>
            <label>Inspector</label>
            <md-select placeholder="Select Inspector" v-model="inspectorId">
                <md-option v-for="inspector in inspectorList" :key="inspector._id" :value="inspector._id">{{ inspector.name }}</md-option>
            </md-select>
          </md-field>
          <md-field>
            <label>Title</label>
            <md-input v-model="title" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Invoice Number</label>
            <md-input v-model="invoiceNumber" type="text"></md-input>
          </md-field>
          <md-field>
            <md-datepicker v-model="date" md-immediately >
                <label>Select date</label>
                </md-datepicker>   
          </md-field>
          <md-field>
            <input type="file" @change="fileUpload( $event )"  /> 
            <a :href="fileUrl" target="_blank" v-if="fileName"><b>{{ fileName }}</b></a>
          </md-field>
          <div class="md-layout">
            <div class="md-layout-item md-size-50">
                <md-field>
                    <label>Contact Person Name</label>
                    <md-input v-model="contactPersonName" type="text"></md-input>
                </md-field>
            </div>
            <div class="md-layout-item md-size-50">
                <md-field>
                    <label>Contact Person Phone Number</label>
                    <md-input v-model="contactPersonphoneNumber" type="text"></md-input>
                </md-field>
            </div>
          </div>
          <md-field>
            <label>Address</label>
            <md-input v-model="address" type="text"></md-input>
          </md-field>
          <div class="md-layout">
            <div class="md-layout-item md-size-33">
              <md-field>
                <label>City</label>
                <md-input v-model="city" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field>
                <label>State</label>
                <md-input v-model="state" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field>
                <label>Country</label>
                <md-input v-model="country" type="text"></md-input>
              </md-field>
            </div>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button v-if="!inspectionId" class="md-success" :disabled="isDisabled" @click="createInspection()">
            Create <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
          <md-button v-else class="md-success" :disabled="isDisabled" @click="updateInspection()">
            Update <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import InspectorService from "../../services/InspectorService";
import ClientsService from "../../services/ClientsService";
import InspectionsService from "../../services/InspectionsService";
export default {
  components: {},
  data() {
    return {
      inspectionId: this.$route.query.id,
      isDisabled: false,
      clientList: [],
      inspectorList: [],
      clientId:"",
      inspectorId: "",
      title: "",
      invoiceNumber: "",
      date: "",
      contactPersonName: "",
      contactPersonphoneNumber: "",
      address:"",
      city:"",
      state:"",
      country:"",
      instructionFile: null,
      fileName: "",
      fileUrl: "",
    };
  },
  methods: {
    fileUpload(event){
      this.instructionFile = event.target.files[0];
    },
    async createInspection() {
      this.isDisabled = true;
      let formData = new FormData();
      formData.append("instructionFile", this.instructionFile);
      formData.append("clientId", this.clientId);
      formData.append("inspectorId", this.inspectorId);
      formData.append("title", this.title);
      formData.append("invoiceNumber", this.invoiceNumber);
      formData.append("date", this.date);
      formData.append("contactPersonName", this.contactPersonName);
      formData.append("contactPersonphoneNumber", this.contactPersonphoneNumber);
      formData.append("address", this.address);
      formData.append("city", this.city);
      formData.append("state", this.state);
      formData.append("country", this.country);
      await InspectionsService.createInspection(formData)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.$router.push('inspections');
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async updateInspection() {
      this.isDisabled = true;
      let formData = new FormData();
      formData.append("id", this.inspectionId);
      formData.append("instructionFile", this.instructionFile);
      formData.append("clientId", this.clientId);
      formData.append("inspectorId", this.inspectorId);
      formData.append("title", this.title);
      formData.append("invoiceNumber", this.invoiceNumber);
      formData.append("date", this.date);
      formData.append("contactPersonName", this.contactPersonName);
      formData.append("contactPersonphoneNumber", this.contactPersonphoneNumber);
      formData.append("address", this.address);
      formData.append("city", this.city);
      formData.append("state", this.state);
      formData.append("country", this.country);
      await InspectionsService.updateInspection(formData)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.$router.push('inspections');
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    getClients() {
      let data = {
        sortByName: true,
      }
      ClientsService.getClients(data)
        .then((response) => {
            this.clientList = response.data.data;
        }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    getInspectors() {
      let data = {
        sortByName: true,
      }
      InspectorService.getInspectors(data)
        .then((response) => {
            this.inspectorList = response.data.data;
        }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getInspectionDetail() {
      this.isDisabled = true;
      let data = { id: this.inspectionId }
      await InspectionsService.getInspectionDetail(data)
        .then((response) => {
            this.isDisabled = false;
            let inspectionDetails = response.data.data
            this.title = inspectionDetails.title;
            this.clientId = inspectionDetails.clientId;
            this.inspectorId = inspectionDetails.inspectorId;
            this.invoiceNumber = inspectionDetails.invoiceNumber;
            this.date = new Date(inspectionDetails.date);
            this.contactPersonName = inspectionDetails.contactPersonName;
            this.contactPersonphoneNumber = inspectionDetails.contactPersonphoneNumber;
            this.fileName = inspectionDetails.instructionFile;
            this.fileUrl =  inspectionDetails.fileUrl;
            this.address = inspectionDetails.address;
            this.city = inspectionDetails.city;
            this.state = inspectionDetails.state;
            this.country = inspectionDetails.country;
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    }
  },
  beforeMount() {
    this.getClients();
    this.getInspectors();
    if (this.$route.query.id) {
      this.getInspectionDetail();
    }
  },
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}
</style>
